//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import LookerDashboardComponent from '@/components/LookerDashboardComponent';
// Importa Somos1Service si lo necesitas

export default {
  name: 'MonitoringReportsView',
  components: {
    LookerDashboardComponent: LookerDashboardComponent
  },
  data: function data() {
    return {
      dashboardUrl: '',
      report: {},
      maintenance: true,
      keyTemplate: 1
    };
  },
  created: function created() {
    var reportId = this.$route.query.v;
    var multiorg = this.$route.query.m;
    console.log(reportId);
    if (reportId) {
      this.getReport(reportId, multiorg);
    } else {
      console.error('No report_id provided');
    }
  },
  methods: {
    onReloadDashboard: function onReloadDashboard() {
      var reportId = this.$route.query.v;
      var multiorg = this.$route.query.m;
      this.getReport(reportId, multiorg);
    },
    getReport: function getReport(reportId, multiorg) {
      var _this = this;
      var data = {
        'document_id': reportId,
        'multiorg': multiorg
      };
      MonitoringAccessService.getBillingMonitoringById(data).then(function (response) {
        _this.report = response.data;
        var v_params = [];
        if (_this.report.keys.length > 0) {
          for (var i = 0; i < _this.report.keys.length; i++) {
            v_params.push("\"v".concat(i + 1, "\":\"").concat(_this.report.keys[i], "\""));
          }
        }
        var v_params_string = v_params.join(',');
        var calc_query = '?params={' + v_params_string + '}';
        _this.dashboardUrl = _this.report.link + calc_query;
        _this.maintenance = _this.report.maintenance;
        console.log(_this.dashboardUrl, 'dashboardUrl');
        _this.keyTemplate += 1;
      });
    }
  },
  computed: {
    // Tus métodos computados
  }
};